// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"checkbox_wrapper__yaS_L","label":"checkbox_label__mnztV","input":"checkbox_input__AOBLd","checkbox":"checkbox_checkbox__dcTjA"};